import {faScrewdriverWrench} from '@fortawesome/pro-regular-svg-icons';
import {
  Burger,
  Drawer,
  Group,
  ModalBaseOverlayProps,
  Stack,
  Title,
} from '@mantine/core';
import {FC, useCallback, useState} from 'react';
import {Env} from '../config/env-vars.ts';
import {ROUTES} from '../routes';
import {useMedia} from '../styles/breakpoints';
import {User} from '../types';
import {PrimaryNavLinkItems, SubNavItems} from './links.tsx';
import {PrimaryNavLink} from './primary-nav-link.tsx';
import {SubNavMenu} from './sub-nav-menu.tsx';
import {UserMenu} from './user-menu.tsx';

type PrimaryNavigation = {
  user: User;
};

export const PrimaryNavigation: FC<PrimaryNavigation> = () => {
  const isDesktopMin = useMedia('DesktopMin');

  return (
    <Group mx={10} justify={'space-between'} h={50} align={'center'}>
      <Group>
        <PrimaryNavLink {...PrimaryNavLinkItems.Dashboard} />
        {isDesktopMin && <DesktopNavigation />}
      </Group>
      <Group>
        <UserMenu />
        {!isDesktopMin && <MobileNavigation />}
      </Group>
    </Group>
  );
};

// eslint-disable-next-line @typescript-eslint/no-unused-vars
const DEMO_TAB = () =>
  Env.isLocal ? (
    <PrimaryNavLink
      to={ROUTES.DEMO.path}
      title={'Demo'}
      icon={faScrewdriverWrench}
    />
  ) : null;

const DesktopNavigation = () => (
  <Group gap='lg'>
    <PrimaryNavLink {...PrimaryNavLinkItems.Jobs} />
    <PrimaryNavLink {...PrimaryNavLinkItems.Reviews} />
    <PrimaryNavLink {...PrimaryNavLinkItems.RepairDocuments} />
    <PrimaryNavLink {...PrimaryNavLinkItems.PartnerSites} />
    <PrimaryNavLink {...PrimaryNavLinkItems.Users} />
    <PrimaryNavLink {...PrimaryNavLinkItems.EmailLog} />
    <SubNavMenu {...SubNavItems.ConfigurationSubNavItem} />
    <PrimaryNavLink {...PrimaryNavLinkItems.Settings} />
    {/* <PrimaryNavLink {...PrimaryNavLinkItems.Logs} />
    <PrimaryNavLink {...PrimaryNavLinkItems.Routes} />
    <DEMO_TAB /> */}
  </Group>
);

const MobileNavigation = () => {
  const [drawerOpened, setDrawerOpened] = useState(false);

  const toggleDrawer = useCallback(
    () => setDrawerOpened(!drawerOpened),
    [drawerOpened],
  );

  return (
    <>
      <Burger opened={drawerOpened} onClick={toggleDrawer} size='sm' />
      <Drawer
        withOverlay
        overlayProps={mobileMenuOverlayProps}
        opened={drawerOpened}
        onClose={() => setDrawerOpened(false)}
        title={mobileMenuTitle}
        size={'xs'}
        position='right'
      >
        <Stack>
          <PrimaryNavLink {...PrimaryNavLinkItems.Jobs} />
          <PrimaryNavLink {...PrimaryNavLinkItems.RepairDocuments} />
          <PrimaryNavLink {...PrimaryNavLinkItems.Reviews} />
          <PrimaryNavLink {...PrimaryNavLinkItems.PartnerSites} />
          <PrimaryNavLink {...PrimaryNavLinkItems.ActionClasses} />
          <PrimaryNavLink {...PrimaryNavLinkItems.ActionCodes} />
          <PrimaryNavLink {...PrimaryNavLinkItems.Codes} />
          <PrimaryNavLink {...PrimaryNavLinkItems.Fields} />
          <PrimaryNavLink {...PrimaryNavLinkItems.EmailEvaluations} />
          <PrimaryNavLink {...PrimaryNavLinkItems.Users} />
          <PrimaryNavLink {...PrimaryNavLinkItems.EmailLog} />
          <PrimaryNavLink {...PrimaryNavLinkItems.Settings} />
          {/* <PrimaryNavLink {...PrimaryNavLinkItems.Logs} />
          <PrimaryNavLink {...PrimaryNavLinkItems.Routes} />
          <DEMO_TAB /> */}
        </Stack>
      </Drawer>
    </>
  );
};

const mobileMenuOverlayProps: ModalBaseOverlayProps = {
  blur: 3,
  opacity: 0.5,
};
const mobileMenuTitle = <Title order={2}>Navigation</Title>;
